var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M23.645,10.245l-.024-.019-11-9a1,1,0,0,0-1.266,0l-11,9a1,1,0,0,0,1.266,1.548l1.367-1.118V22a1,1,0,0,0,1,1h16a1,1,0,0,0,1-1V10.656l1.367,1.118a1,1,0,0,0,1.29-1.529ZM12,8a2.5,2.5,0,1,1-2.5,2.5A2.5,2.5,0,0,1,12,8ZM7,20a5,5,0,0,1,10,0Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }